import type { MapMouseEvent } from 'mapbox-gl';

/**
 * Whether a map click landed on the map canvas itself. HTML markers and popups live inside the
 * canvas container, so a click on one also fires the map's layer click handlers for whatever
 * rendered feature sits underneath; a layer handler should ignore those so only the topmost item
 * is selected.
 */
export function clickedMapCanvas(event: Pick<MapMouseEvent, 'originalEvent' | 'target'>): boolean {
  return event.originalEvent.target === event.target.getCanvas();
}
